import React from 'react';
import styled from 'styled-components';

const FigCaption = (props) => {
    const StyledFigCaption = styled.figcaption`
       ${props => props.theme.typography.caption};
    `;

    return (
        <StyledFigCaption dangerouslySetInnerHTML={{ __html: props.children }} />
    );
};

export default FigCaption;



// WEBPACK FOOTER //
// ./src/components/common/FigCaption.js